var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "compact-container pl-3" }, [
          _c(
            "a",
            {
              staticClass: "cursor-pointer mr-2 help-container",
              attrs: {
                "aria-controls": "collapseHelp",
                "aria-expanded": "false",
                "data-target": "#collapseHelp",
                "data-toggle": "collapse",
                role: "button"
              }
            },
            [
              _c("section-title", {
                attrs: {
                  "container-class": "section-container",
                  icon: "far fa-question-circle",
                  title: "Ayuda",
                  "title-class": "help-container-title"
                }
              })
            ],
            1
          ),
          _c(
            "a",
            [
              _c("section-title", {
                attrs: {
                  "container-class": "section-container-solid",
                  icon: "fas fa-book",
                  title: ""
                }
              })
            ],
            1
          ),
          _c(
            "a",
            { staticClass: "ml-n5" },
            [
              _c("section-title", {
                attrs: {
                  "container-class": "section-container-solid",
                  icon: "fas fa-video",
                  title: ""
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "collapse compact-body ml-n1",
        attrs: { id: "collapseHelp" }
      },
      [
        _c(
          "a",
          { staticClass: "dropdown-item support-table shadow-top pb-n3 pt-2" },
          [
            _c("div", { staticClass: "div-help" }, [
              _c("strong", [_vm._v("Mesa de Apoyo")])
            ])
          ]
        ),
        _c(
          "a",
          {
            staticClass: "d-flex align-items-center support-information",
            attrs: { href: "#" }
          },
          [
            _c("div", { staticClass: "help-information mt-n4" }, [
              _c("i", { staticClass: "fas fa-phone-square-alt" })
            ]),
            _c("div", { staticClass: "support-label" }, [
              _c("span", [_vm._v("787-773-6147")])
            ])
          ]
        ),
        _c(
          "a",
          {
            staticClass:
              "d-flex align-items-center support-information email-field",
            attrs: { href: "mailto:apoyoconversion@de.pr.gov" }
          },
          [
            _c("div", { staticClass: "help-information mt-n4" }, [
              _c("i", { staticClass: "fas fa-envelope" })
            ]),
            _c("div", { staticClass: "support-label" }, [
              _c("span", { staticClass: "text-decoration-underline" }, [
                _c("u", [_vm._v("apoyoconversion@de.pr.gov")])
              ])
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }